import { FC, SVGProps } from 'react'
import classNames from 'classnames' // we need this to make JSX compile

type NavLogoType = SVGProps<SVGSVGElement> & {}

const NavLogo: FC<NavLogoType> = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M14.9115 6.07275L12.8517 9.24843L14.0159 9.35087L9.09045 13.6534L10.9711 10.4777H10.1154L10.9711 6.07275H10.5785H6.78516V17.9268H10.5785V15.6431L13.4234 13.1579V17.9268H17.2168V6.07275H14.9115Z'
        className='text-pink2'
      />
      <circle cx='12' cy='12' r='11' className='stroke-pink2' strokeWidth='2' />
    </svg>
  )
}

export default NavLogo
